import { render, staticRenderFns } from "./Colorpicker.vue?vue&type=template&id=90fbf57c&"
import script from "./Colorpicker.vue?vue&type=script&lang=ts&"
export * from "./Colorpicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports